
const ComplementoPagosRules = (data) => {
  const tipoCambioRule = data.MonedaP !== 'MXN' ? 'required' : 'string';

  return {
    FechaPago: [
      'required'
    ],
    HoraPago: [
      'required',
      'string',
      'regex:/^[0-9]{2}:[0-9]{2}$/'
    ],
    FormaDePagoP: [
      'required',
      'string',
      'in:01,02,03,04,05,06,08,12,13,14,15,17,23,24,25,26,27,28,29,30,31,99'
    ],
    MonedaP: [
      'required',
      'string'
    ],
    TipoCambioP: [
      tipoCambioRule
    ],
    Monto: [
      'required',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/'
    ],
    NumOperacion: [
      'string',
      'min:1',
      'max:100',
      'regex:/^[^|]{1,100}$/',
    ],
    CtaOrdenante: [
      'string',
      'min:10',
      'max:50',
      'regex:/^[A-Z0-9_]{10,50}$/'
    ],
    CtaBeneficiario: [
      'string',
      'min:10',
      'max:50',
      'regex:/^[A-Z0-9_]{10,50}$/'
    ]
  }
}

export default ComplementoPagosRules;